import http_request from './http_request'
import agentTypes from 'helpers/enums/agentTypes'
import config from 'config'
import animations from 'animations/paths'

function updateBoard(token, newBoardId, parentId, name) {
	return http_request.post(`${config.collaborate_api}boards/${parentId}/clone`)
		.setAgentType(agentTypes.RAW)
		.withHeaders({Authorization: token})
		.send({
			newBoardId,
			name,
		})
}

function createLesson() {
	return http_request.post(`${config.api}first_lesson/setup`)
		.send()
}

function enableFirstLesson(presentationId) {
	return http_request.put(`${config.api}first_lesson/undelete`)
		.send({
			presentationId,
		})
}

function loadAsset() {
	return http_request.get(animations.ONBOARDING_ACTIVITY_TRANSITION)
		.setAgentType(agentTypes.RAW)
		.type(null)
		.withCredentials(false)
		.send()
}

export default {
	createLesson,
	enableFirstLesson,
	updateBoard,
	loadAsset,
}
